export default __webpack_public_path__ + "static/media/9.5285efa0.png";